module.exports = __webpack_public_path__ + "assets/fonts/menu-alt.8e531892.svg";